import { render } from "./Location.vue?vue&type=template&id=1ec536ba"
import script from "../js/location.js?vue&type=script&lang=js&external"
export * from "../js/location.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__